module.exports = __webpack_public_path__ + "media/images/flags/1x1/esh-bb822d47fedfd7c1abb65552af596b73.svg";